import React, { useEffect, useMemo, useRef, useState } from "react"
import SignContainer from "../../component/sign/signContainer"
import indexStyl from './index.module.scss'
import { makeUploadHeaders, makeUploadName, makeUploadOptions } from "../../component/ocr-autofill/utils"
import alioss from 'ali-oss'
import { Modal, Toast } from "antd-mobile"
import utils from '../../utils/utils'
import { signAgreementQuery, SignAgreementResult, SignState, subjectScanCodeBinding } from "../../api/data"
import { signAgreement } from "../../api/plat"
import { CheckCircleFill, ExclamationCircleOutline } from "antd-mobile-icons"
import { ApiCore } from "../../api"
import ChooseModal, { Value } from "./ChooseModal"

const api = new ApiCore()

//
const makeNowPlaceholder = (fromDoctor: boolean)=> {
  const n = new Date()
  const pieces = {
    keys: ['year', 'month', 'day'],
    values: [n.getFullYear(), n.getMonth() + 1, n.getDate()],
  }
  if(fromDoctor) {
    return pieces
  }
  pieces.keys[0] = 'signyear'
  pieces.keys[1] = 'signmonth'
  pieces.keys[2] = 'signday'
  return pieces
}

//
const reLaunch = (q: string)=> {
  if(utils.isMiniProgram()) {
    window.wx.miniProgram.reLaunch({
      url: '/pages/webview/webview?q=' + encodeURIComponent(q)
    })
  } else {
    window.location.replace(q)
  }
}

// 
enum SignCodeEnum {
  None, // 未签名
  Draw, // 签名已替换到页面预览
  Submit, // 签名已提交保存
}

type SignAgreementProps = {
  // 医生签名时传参
  fromDoctor?: boolean;
  subjectCode?: string;
  redirect?: ()=> void;
}
const SignAgreement: React.FC<SignAgreementProps> = (props)=> {

  const [chooseValue, setChooseValue] = useState<Value>()
  const [chooseModalVisible, setChooseModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [signCode, setSignCode] = useState(SignCodeEnum.None)
  const [mobileNotMatch, setMobileNotMatch] = useState(false)

  const [subjectCode] = useState(()=> {
    if(props.subjectCode) {
      return props.subjectCode
    }
    const [_, querystring] = window.location.href.split('?')
    if(!querystring) {
      return ''
    }
    const params = new URLSearchParams(querystring)
    return params.get('subjectCode') ?? ''
  })

  const [fromDoctor] = useState(()=> {
    if(props.fromDoctor) {
      return true
    }
    return false
  })

  const [info, setInfo] = useState({} as SignAgreementResult)

  const safeAreaStyle = useMemo(()=> {
    const { userAgent } = window.navigator
    if(userAgent.toLowerCase().indexOf('iphone') === -1) {
      return {
        paddingBottom: 0
      }
    }
    return {
      paddingBottom: 16
    }
  }, [])
  
  const signContainerRef = useRef(null)

  // 已替换签名日期
  const signDateReplRef = useRef(false)

  // 
  const iframeRef = useRef<HTMLIFrameElement>(null)

  //#region 上传签名
  const startUpload = async (dataURI: string)=> {
    const file = utils.base64ToFile(dataURI, 'sign')

    const pieces = await makeUploadOptions();

    if (!pieces) {
      return;
    }

    const [prefix, options] = pieces;

    const client = new alioss(options);

    const pathname = makeUploadName(prefix, file);

    if (!pathname) {
      Modal.alert("提示", "上传缺少必要参数");
      return;
    }

    // 上传图片到OSS
    const result = await client.put(pathname, file, {
      timeout: 600 * 1000,
      headers: makeUploadHeaders(0),
    });

    if (result.res.status === 200) {
      return result.url
    }
    Modal.alert("提示", "上传失败，请重试！");
  }
  //#endregion

  // 签名画板
  const openSignPanel = ()=> {
    if(fromDoctor) {
      // @ts-ignore
      signContainerRef.current.toShowModal()
    } else {
      setChooseModalVisible(true)
    }
  }

  // 如果是试试者签署需要确认签署者类型
  const chooseConfirm = (value: Value)=> {
    setChooseValue(value)
    setChooseModalVisible(false)
    // @ts-ignore
    signContainerRef.current.toShowModal()
  }

  const onUpdateSignUrl = async(dataURI: string)=> {
    if(!iframeRef.current) {
      return
    }

    Toast.loading("正在处理...")

    const url = await startUpload(dataURI)

    if(!url) {
      Toast.hide()
      return;
    }

    setSignCode(SignCodeEnum.Draw)
    const contentDocument = iframeRef.current.contentDocument as Document
    const elements = contentDocument.querySelectorAll('span')

    let relationContent = ''
    let findContent = '研究者签名';
    if(!fromDoctor) {
      if(!chooseValue) {
        Toast.hide()
        return
      }
      relationContent = chooseValue.relation
      findContent = chooseValue.type
    }

    const repl = makeNowPlaceholder(fromDoctor)

    const elementList = Array.from(elements)
    for(const el of elementList) {
      // 签字日期
      if(!signDateReplRef.current) {
        let skip = false;
        for(const i in repl.keys) {
          if(el.innerHTML.indexOf(`<!--${repl.keys[i]}-->`) === 0) {
            el.innerHTML = String(repl.values[i])
            skip = true;
            break;
          }
        }
        if(skip) {
          continue;
        }
      }

      // 根据注释内容查找
      if(el.innerHTML.indexOf(`<!--${findContent}-->`) === -1) {
        continue;
      }

      // 先删除旧的
      let imgEl = el.querySelector('img')
      if(!imgEl) {
        el.appendChild(imgEl = contentDocument.createElement('img'))
        imgEl.setAttribute('style', 'width: 100px')
      }

      imgEl.src = url;
      // 替换关系
      if(findContent === '监护人签名') {
        for(const element of elementList) {
          
          if(element.innerHTML.indexOf('<!--患者关系-->') > -1) {
            let emEl = element.querySelector('em')
            if(!emEl) {
              element.appendChild(emEl = contentDocument.createElement('em'))
              emEl.style.fontStyle = 'normal'
            }
            emEl.textContent = relationContent
            break;
          }
        }
      }
    }

    signDateReplRef.current = true

    Toast.hide()
  }

  // 跳转到绑定页面
  const redirectBinding = async ()=> {
    // 初始化绑定信息
    const {code, message, data} = await subjectScanCodeBinding(subjectCode, info.createUser)
    if(code === 0) {
      setTimeout(()=> reLaunch(data.scanCodeUrl), 2000)
    } else {
      Toast.fail(message)
    }
  }

  const onConfirm = async()=> {
    if(!iframeRef.current) {
      return
    }

    const iframeDocument = iframeRef.current.contentDocument
    if(!iframeDocument) {
      return
    }

    setLoading(true)

    Toast.loading("正在处理...")

    
    const htmlEl = iframeDocument.querySelector('html') as HTMLHtmlElement

    const { code, message } = await signAgreement({
      subjectCode,
      agreement: htmlEl.outerHTML
    }, fromDoctor)

    Toast.hide()
    setLoading(false)

    if(code !== 0) {
      Toast.fail(message)
    }

    // 医生签署返回医生业务页面
    if(props.redirect) {
      props.redirect()
      return
    }

    // 受试者需要进行协议签署后的步骤
    Toast.info('协议签署成功')

    await redirectBinding()
  }

  const fetchData = async (callback: (content: string)=> void)=> {

    if(!subjectCode) {
      Toast.fail('页面错误参数不完整')
      return
    }

    const { code, message, data } = await signAgreementQuery(subjectCode, fromDoctor)
    
    if(code > 0) {
      // 手机号码未匹配
      if(code === 50031414) {
        setMobileNotMatch(true)
      } else {
        Toast.fail(message)
      }
      return
    }

    let signed = false
    // 全部已签
    if(data.signatureState === SignState.All) {
      signed = true
    } else {
      if(fromDoctor) {
        // 医生已签名
        if(data.signatureState === SignState.Doctor) {
          signed = true
        }
      } else {
        // 受试者已签名
        if(data.signatureState === SignState.Examinee) {
          signed = true
        }
      }
    }

    if(signed) {
      if(fromDoctor) {
        Toast.info('您已签名，请勿重复签名', 2, props.redirect)
      } else {
        const d = await api.getSubjectBindingInfo({subjectCode})
        // 已绑定直接重定向
        if(1 === d.data.bindState) {
          reLaunch('/pages/webview/webview?fromUrlFromH5=/epro/patient/home&toBeforeH5Url=1&from=EPRO_PT&projectCode=' + data.projectCode)
        } else {
          await redirectBinding()
        }
      }
      return
    }

    setInfo(data)

    callback(data.agreement)
  }

  useEffect(()=> {
    window.document.title = '服务协议签署'
  }, [])

  const inited = useRef(false)
  useEffect(()=> {
    if(iframeRef.current && !inited.current) {
      inited.current = true
      fetchData((content: string)=> {
        const iframe = iframeRef.current as HTMLIFrameElement
        const contentWindow = iframe.contentWindow as Window
        contentWindow.document.write(content)
      })
    }
  }, [iframeRef.current])

  return (
    <>
      <div className={indexStyl.container} style={safeAreaStyle}>
        <iframe ref={iframeRef} className={indexStyl.ifr}></iframe>
        <div className={indexStyl.footer}>
          {
            signCode === SignCodeEnum.Draw && (
              <>
                <button onClick={openSignPanel} type="button" className={indexStyl.cancelButton}>重新签名</button>
                {
                  !fromDoctor && (
                    <button onClick={()=> setChooseModalVisible(true)} type="button">继续签名</button>
                  )
                }
                <button disabled={loading} onClick={onConfirm} type="button">提交签名</button>
              </>
            )
          }
          {
            1 === info.informed && signCode === SignCodeEnum.None && (
              <button onClick={openSignPanel} type="button">立即签名</button>
            )
          }
        </div>
      </div>
      <SignContainer ref={signContainerRef} updateSignUrl={onUpdateSignUrl}/>
      {
        mobileNotMatch && (
          <div className={indexStyl.fullscreen}>
            <p>
              <ExclamationCircleOutline style={{color: '#f13333'}}/>
            </p>
            <p>签署提示</p>
            <p>微信授权的手机号和医生指定的不一致</p>
          </div>
        )
      }
      {
        signCode === SignCodeEnum.Submit && (
          <div className={indexStyl.fullscreen}>
            <p>
              <CheckCircleFill style={{color: '#16d316'}}/>
            </p>
            <p>协议签署成功</p>
            <p>您现在可以退出小程序</p>
          </div>
        )
      }
      {
        chooseModalVisible && <ChooseModal onClose={()=> setChooseModalVisible(false)} onConfirm={chooseConfirm} />
      }
  </>
  )
}

export default SignAgreement
